import React, { useState } from 'react';
import { 
  Building2, 
  DollarSign, 
  Car, 
  TrendingUp, 
  TrendingDown, 
  MapPin, 
  Calendar,
  Users,
  BarChart3,
  ArrowUpRight,
  ArrowDownRight,
  Target,
  Clock,
  LineChart,
  Activity,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronDown
} from 'lucide-react';

// Monthly trend data
const monthlyTrendData = [
  {
    month: 'Haziran 2024',
    shortMonth: 'Haz',
    totalRevenue: 10950000,
    totalFleet: 1050,
    averageUtilization: 81.5,
    totalCustomers: 4950,
    revenuePerVehicle: 10428, // Revenue / Fleet
    averageDailyRate: 285,     // Average daily rental rate
    revenuePerCustomer: 2212,  // Revenue / Customer
    branchCount: 6
  },
  {
    month: 'Temmuz 2024',
    shortMonth: 'Tem',
    totalRevenue: 11830000,
    totalFleet: 1060,
    averageUtilization: 83.4,
    totalCustomers: 5370,
    revenuePerVehicle: 11160,
    averageDailyRate: 295,
    revenuePerCustomer: 2203,
    branchCount: 6
  },
  {
    month: 'Ağustos 2024',
    shortMonth: 'Ağu',
    totalRevenue: 13530000,
    totalFleet: 1080,
    averageUtilization: 87.9,
    totalCustomers: 7812,
    revenuePerVehicle: 12527,
    averageDailyRate: 310,
    revenuePerCustomer: 1732,
    branchCount: 6
  },
  {
    month: 'Eylül 2024',
    shortMonth: 'Eyl',
    totalRevenue: 13800000,
    totalFleet: 1090,
    averageUtilization: 86.2,
    totalCustomers: 7654,
    revenuePerVehicle: 12660,
    averageDailyRate: 305,
    revenuePerCustomer: 1802,
    branchCount: 6
  },
  {
    month: 'Ekim 2024',
    shortMonth: 'Eki',
    totalRevenue: 15200000,
    totalFleet: 1120,
    averageUtilization: 89.1,
    totalCustomers: 8123,
    revenuePerVehicle: 13571,
    averageDailyRate: 320,
    revenuePerCustomer: 1871,
    branchCount: 6
  },
  {
    month: 'Kasım 2024',
    shortMonth: 'Kas',
    totalRevenue: 16850000,
    totalFleet: 1150,
    averageUtilization: 91.4,
    totalCustomers: 8967,
    revenuePerVehicle: 14652,
    averageDailyRate: 335,
    revenuePerCustomer: 1879,
    branchCount: 6
  }
];

// Branch-specific monthly trends (all 6 branches)
const branchMonthlyTrends = {
  'Istanbul Atatürk Airport': [
    { month: 'Haz', revenue: 2650000, utilization: 85.2, customers: 1180, satisfaction: 4.6 },
    { month: 'Tem', revenue: 2780000, utilization: 87.1, customers: 1230, satisfaction: 4.7 },
    { month: 'Ağu', revenue: 2950000, utilization: 89.3, customers: 1290, satisfaction: 4.8 },
    { month: 'Eyl', revenue: 2850000, utilization: 88.1, customers: 1210, satisfaction: 4.7 },
    { month: 'Eki', revenue: 3100000, utilization: 90.5, customers: 1350, satisfaction: 4.8 },
    { month: 'Kas', revenue: 3350000, utilization: 92.1, customers: 1420, satisfaction: 4.9 }
  ],
  'Ankara Esenboğa Airport': [
    { month: 'Haz', revenue: 1850000, utilization: 78.3, customers: 820, satisfaction: 4.4 },
    { month: 'Tem', revenue: 1950000, utilization: 80.5, customers: 870, satisfaction: 4.5 },
    { month: 'Ağu', revenue: 2080000, utilization: 82.7, customers: 920, satisfaction: 4.6 },
    { month: 'Eyl', revenue: 2020000, utilization: 81.9, customers: 890, satisfaction: 4.5 },
    { month: 'Eki', revenue: 2200000, utilization: 84.2, customers: 980, satisfaction: 4.6 },
    { month: 'Kas', revenue: 2380000, utilization: 86.8, customers: 1050, satisfaction: 4.7 }
  ],
  'İzmir Adnan Menderes': [
    { month: 'Haz', revenue: 1650000, utilization: 79.1, customers: 740, satisfaction: 4.3 },
    { month: 'Tem', revenue: 1720000, utilization: 81.3, customers: 780, satisfaction: 4.4 },
    { month: 'Ağu', revenue: 1850000, utilization: 83.5, customers: 820, satisfaction: 4.5 },
    { month: 'Eyl', revenue: 1780000, utilization: 82.8, customers: 790, satisfaction: 4.4 },
    { month: 'Eki', revenue: 1920000, utilization: 85.1, customers: 850, satisfaction: 4.5 },
    { month: 'Kas', revenue: 2050000, utilization: 87.6, customers: 910, satisfaction: 4.6 }
  ],
  'Antalya Airport': [
    { month: 'Haz', revenue: 2100000, utilization: 88.5, customers: 950, satisfaction: 4.5 },
    { month: 'Tem', revenue: 2350000, utilization: 91.2, customers: 1080, satisfaction: 4.6 },
    { month: 'Ağu', revenue: 2650000, utilization: 94.1, customers: 1220, satisfaction: 4.8 },
    { month: 'Eyl', revenue: 2200000, utilization: 89.7, customers: 1010, satisfaction: 4.6 },
    { month: 'Eki', revenue: 1950000, utilization: 83.2, customers: 890, satisfaction: 4.4 },
    { month: 'Kas', revenue: 1780000, utilization: 79.8, customers: 810, satisfaction: 4.3 }
  ],
  'Bursa City Center': [
    { month: 'Haz', revenue: 980000, utilization: 76.2, customers: 440, satisfaction: 4.2 },
    { month: 'Tem', revenue: 1050000, utilization: 78.5, customers: 470, satisfaction: 4.3 },
    { month: 'Ağu', revenue: 1150000, utilization: 81.3, customers: 520, satisfaction: 4.4 },
    { month: 'Eyl', revenue: 1080000, utilization: 79.8, customers: 480, satisfaction: 4.3 },
    { month: 'Eki', revenue: 1180000, utilization: 83.1, customers: 530, satisfaction: 4.4 },
    { month: 'Kas', revenue: 1280000, utilization: 86.4, customers: 580, satisfaction: 4.5 }
  ],
  'Trabzon Airport': [
    { month: 'Haz', revenue: 720000, utilization: 73.8, customers: 320, satisfaction: 4.1 },
    { month: 'Tem', revenue: 780000, utilization: 76.2, customers: 350, satisfaction: 4.2 },
    { month: 'Ağu', revenue: 850000, utilization: 79.1, customers: 380, satisfaction: 4.3 },
    { month: 'Eyl', revenue: 800000, utilization: 77.5, customers: 360, satisfaction: 4.2 },
    { month: 'Eki', revenue: 890000, utilization: 81.3, customers: 400, satisfaction: 4.3 },
    { month: 'Kas', revenue: 950000, utilization: 84.7, customers: 430, satisfaction: 4.4 }
  ]
};

// Dummy data for Sixt store/branch performance
const branchData = [
  {
    id: 1,
    name: 'Istanbul Atatürk Airport',
    location: 'Istanbul, Turkey',
    revenue: 2850000,
    revenueGrowth: 12.5,
    vehicleUtilization: 87.3,
    totalFleet: 180,
    activeRentals: 157,
    totalCustomers: 1420,
    customerSatisfaction: 4.7,
    averageDailyRate: 345,        // Average price per day
    revenuePerVehicle: 15833,     // Revenue / Fleet
    revenuePerCustomer: 2007,     // Revenue / Customer
    fleetStatus: {
      available: 23,
      rented: 157,
      maintenance: 8,
      outOfService: 2
    }
  },
  {
    id: 2,
    name: 'Ankara Esenboğa Airport',
    location: 'Ankara, Turkey',
    revenue: 2020000,
    revenueGrowth: 8.3,
    vehicleUtilization: 84.2,
    totalFleet: 120,
    activeRentals: 101,
    totalCustomers: 980,
    customerSatisfaction: 4.5,
    averageDailyRate: 315,
    revenuePerVehicle: 16833,
    revenuePerCustomer: 2061,
    fleetStatus: {
      available: 19,
      rented: 101,
      maintenance: 5,
      outOfService: 1
    }
  },
  {
    id: 3,
    name: 'İzmir Adnan Menderes',
    location: 'İzmir, Turkey',
    revenue: 1780000,
    revenueGrowth: 6.1,
    vehicleUtilization: 85.1,
    totalFleet: 100,
    activeRentals: 85,
    totalCustomers: 850,
    customerSatisfaction: 4.4,
    averageDailyRate: 295,
    revenuePerVehicle: 17800,
    revenuePerCustomer: 2094,
    fleetStatus: {
      available: 15,
      rented: 85,
      maintenance: 4,
      outOfService: 1
    }
  },
  {
    id: 4,
    name: 'Antalya Airport',
    location: 'Antalya, Turkey',
    revenue: 2200000,
    revenueGrowth: -15.2,
    vehicleUtilization: 83.2,
    totalFleet: 140,
    activeRentals: 116,
    totalCustomers: 890,
    customerSatisfaction: 4.3,
    averageDailyRate: 380,
    revenuePerVehicle: 15714,
    revenuePerCustomer: 2472,
    fleetStatus: {
      available: 24,
      rented: 116,
      maintenance: 6,
      outOfService: 2
    }
  },
  {
    id: 5,
    name: 'Bursa City Center',
    location: 'Bursa, Turkey',
    revenue: 1180000,
    revenueGrowth: 14.7,
    vehicleUtilization: 83.1,
    totalFleet: 60,
    activeRentals: 50,
    totalCustomers: 530,
    customerSatisfaction: 4.6,
    averageDailyRate: 285,
    revenuePerVehicle: 19667,
    revenuePerCustomer: 2226,
    fleetStatus: {
      available: 10,
      rented: 50,
      maintenance: 3,
      outOfService: 1
    }
  },
  {
    id: 6,
    name: 'Trabzon Airport',
    location: 'Trabzon, Turkey',
    revenue: 800000,
    revenueGrowth: 9.8,
    vehicleUtilization: 81.3,
    totalFleet: 40,
    activeRentals: 33,
    totalCustomers: 400,
    customerSatisfaction: 4.2,
    averageDailyRate: 275,
    revenuePerVehicle: 20000,
    revenuePerCustomer: 2000,
    fleetStatus: {
      available: 7,
      rented: 33,
      maintenance: 2,
      outOfService: 0
    }
  }
];

const fleetMetrics = {
  totalVehicles: 653,
  totalRevenue: 10730000,
  averageUtilization: 77.2,
  totalCustomers: 5281,
  averageSatisfaction: 4.5,
  topPerformingBranch: 'Antalya Airport',
  lowestPerformingBranch: 'Trabzon Airport'
};

export default function SixtStoreBranchPerformance() {
  const [selectedTimeframe, setSelectedTimeframe] = useState('current');
  const [selectedTrendMetric, setSelectedTrendMetric] = useState('revenue');
  const [selectedBranch, setSelectedBranch] = useState('Istanbul Atatürk Airport');
  const [sortBy, setSortBy] = useState('revenue'); // Add back the missing sortBy state
  const [expandedBranches, setExpandedBranches] = useState({}); // Track which branches are expanded
  const [selectedMapBranch, setSelectedMapBranch] = useState(null); // State for map branch selection

  // Toggle branch expansion
  const toggleBranchExpansion = (branchName) => {
    setExpandedBranches(prev => ({
      ...prev,
      [branchName]: !prev[branchName]
    }));
  };

  // Calculate monthly growth
  const calculateGrowth = (current, previous) => {
    if (!previous || previous === 0) return 0;
    return ((current - previous) / previous * 100).toFixed(1);
  };

  const latestMonth = monthlyTrendData[monthlyTrendData.length - 1];
  const previousMonth = monthlyTrendData[monthlyTrendData.length - 2];
  
  const monthlyGrowth = {
    revenue: calculateGrowth(latestMonth.totalRevenue, previousMonth.totalRevenue),
    utilization: calculateGrowth(latestMonth.averageUtilization, previousMonth.averageUtilization),
    customers: calculateGrowth(latestMonth.totalCustomers, previousMonth.totalCustomers),
    roas: calculateGrowth(latestMonth.averageROAS, previousMonth.averageROAS)
  };

  // Calculate average values
  const totalRevenue = branchData.reduce((sum, branch) => sum + branch.revenue, 0);
  const averageUtilization = (branchData.reduce((sum, branch) => sum + branch.vehicleUtilization, 0) / branchData.length).toFixed(1);
  const totalFleet = branchData.reduce((sum, branch) => sum + branch.totalFleet, 0);
  const activeFleet = branchData.reduce((sum, branch) => sum + branch.activeRentals, 0);
  const totalCustomers = branchData.reduce((sum, branch) => sum + branch.totalCustomers, 0);
  const averageSatisfaction = (branchData.reduce((sum, branch) => sum + branch.customerSatisfaction, 0) / branchData.length).toFixed(1);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  const sortedBranches = [...branchData].sort((a, b) => {
    switch (sortBy) {
      case 'revenue':
        return b.revenue - a.revenue;
      case 'utilization':
        return b.vehicleUtilization - a.vehicleUtilization;
      case 'growth':
        return b.revenueGrowth - a.revenueGrowth;
      case 'satisfaction':
        return b.customerSatisfaction - a.customerSatisfaction;
      default:
        return 0;
    }
  });

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <Building2 className="w-8 h-8 text-orange-600" />
            <h1 className="text-3xl font-bold text-gray-900">Store/Branch Performance</h1>
            <div className="px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-sm font-medium">
              Sixt Exclusive
            </div>
          </div>
          <p className="text-gray-600">Monitor and analyze performance across all Sixt locations</p>
        </div>

        {/* Time Range Selector */}
        <div className="mb-6">
          <div className="flex gap-2">
            {[
              { key: 'current_month', label: 'Current Month' },
              { key: 'last_30_days', label: 'Last 30 Days' },
              { key: 'last_quarter', label: 'Last Quarter' },
              { key: 'ytd', label: 'Year to Date' }
            ].map((range) => (
              <button
                key={range.key}
                onClick={() => setSelectedTimeframe(range.key)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  selectedTimeframe === range.key
                    ? 'bg-orange-600 text-white'
                    : 'bg-white text-gray-600 hover:bg-gray-50'
                }`}
              >
                {range.label}
              </button>
            ))}
          </div>
        </div>

        {/* Overview Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Total Revenue</p>
                <p className="text-2xl font-bold text-gray-900">{formatCurrency(fleetMetrics.totalRevenue)}</p>
                <p className="text-sm text-green-600 flex items-center gap-1 mt-1">
                  <TrendingUp className="w-4 h-4" />
                  +8.2% vs last month
                </p>
              </div>
              <DollarSign className="w-8 h-8 text-green-600" />
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Fleet Utilization</p>
                <p className="text-2xl font-bold text-gray-900">{fleetMetrics.averageUtilization}%</p>
                <p className="text-sm text-green-600 flex items-center gap-1 mt-1">
                  <TrendingUp className="w-4 h-4" />
                  +2.1% vs last month
                </p>
              </div>
              <Car className="w-8 h-8 text-blue-600" />
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Total Customers</p>
                <p className="text-2xl font-bold text-gray-900">{fleetMetrics.totalCustomers.toLocaleString()}</p>
                <p className="text-sm text-green-600 flex items-center gap-1 mt-1">
                  <TrendingUp className="w-4 h-4" />
                  +5.7% vs last month
                </p>
              </div>
              <Users className="w-8 h-8 text-purple-600" />
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Avg Satisfaction</p>
                <p className="text-2xl font-bold text-gray-900">{fleetMetrics.averageSatisfaction}/5.0</p>
                <p className="text-sm text-green-600 flex items-center gap-1 mt-1">
                  <TrendingUp className="w-4 h-4" />
                  +0.2 vs last month
                </p>
              </div>
              <Target className="w-8 h-8 text-orange-600" />
            </div>
          </div>
        </div>

        {/* Sort Controls */}
        <div className="mb-6">
          <div className="flex items-center gap-4">
            <span className="text-sm font-medium text-gray-700">Sort by:</span>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
            >
              <option value="revenue">Revenue</option>
              <option value="utilization">Vehicle Utilization</option>
              <option value="growth">Revenue Growth</option>
              <option value="satisfaction">Customer Satisfaction</option>
            </select>
          </div>
        </div>

        {/* Regional Map View */}
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h3 className="text-lg font-semibold mb-4 flex items-center">
            <MapPin className="h-5 w-5 mr-2 text-blue-600" />
            Türkiye Şube Haritası
          </h3>
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Map */}
            <div className="lg:col-span-2">
              <div className="bg-gray-50 rounded-lg p-4 h-96 relative">
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 1000 422"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-full h-full"
                >
                  {/* Complete Turkey Map - All 81 Provinces */}
                  <g fill="#f3f4f6" stroke="#d1d5db" strokeWidth="0.8" className="hover:fill-gray-100 transition-colors duration-300">
                    <path d="M636.7 91.6l0 0.2 0.1 2.2-0.7 1.9-1 1.2-0.8 1.5 0 2 0.8 1.8 0.2 2.1-0.2 2.1 0.2 2.1-0.2 2.1-0.6 1.2-0.2 1.7 4.5 5.1-1.4 1.2-1.6 0.8-2.2 0.2-1.9 0.4-0.5 0.8-0.1 1.8 0.5 0.7-0.2 1.1-1 0.6-4-0.2-1.7 1.3-1.4 1.9-1.4 1.1-1.7 0.2-3.6-2.9-2.6-5.1-0.9-3.8-1.6-3-6.4-0.4-10.9-7.6-3.1-0.3-3.3 0.5-3.4-0.3-3.1-1.3-2.5-1.5-3.9-1.4-2.7-1.6-2.1-0.5-0.6-0.4-0.5-1.9 0.8-1.6 1-0.3 0.9-0.5 2.1-0.2 1.9-0.6 1.7-1 0.7-0.6 1.9-2.1 3.8-2.1 2-3.9 2.7-2.8 2.5-3.5 0-0.3 5.3-0.1 1.7 0.5 1.1 1 0.5 0.3 1 0.3 1.2 0.1 0.8 0.3 1.1 1.3 0.8 0.6 2 0.7 0.2 0.3 1.1 1.2 0.9 0.4 1.9-0.2 0.8 0.2 0.3-0.3 0.6-0.3 0.4-0.3 0.3-0.5 0.6-1.6 0.6-1.1 0.7-1 0.8-0.8 0.9-0.6 0.4 1 0.8 0.6 0.9 0 0.8-0.7 0.3 0.4 1.2-0.2 0.1 3.9 0.8 1.1 2.5 1.2 0.6 0.5 0.5 0.7 0.8 1.4 1.9-0.8 2.2 0.3 5.8 2 0.5 0.1z" id="TR52" />
                    <path d="M591 79.7l0 0.3-2.5 3.5-2.7 2.8-2 3.9-3.8 2.1-1.9 2.1-0.7 0.6-1.7 1-1.9 0.6-2.1 0.2-0.9 0.5-1 0.3-0.8-1.6-1.7-1.1-2.5-0.1-0.3-0.2-0.3 0.4-1.6 0.8-5.2 1.3-5.1-3.7-0.8-1.4-0.6-1.4-1.3-1.5-1.7-0.6-1.9 1.2-0.9 2.9-1.4 2.5-2.2 1.5-1.7 1.4-2 0.5-3.7-1.8-6.3-0.1-1.8-0.3-3.6 0.2-1.6-0.4-1.6-2.8-6.9-5.3-1.6-0.9-2.9 0.5-14.7-4.2-1.8-0.4-3.7 0.4-0.7-2.3-0.3-2.5-0.6-2.3-2.5-4.4 0.8-0.6 1.1-0.5 0.7-0.8-0.4-1.1 0.5-0.5 0.4-0.3 1.2-0.1 0.6-0.2 1.6-1.5 2.5-1 1.2-0.7 0.5-0.9 0.5 0.5 0.4 0.9 0.3 1.2 0.1 1.1 0.3 0.6 0.8 0.5 1.5 0.8-0.5 0.8 0.5 0.3 2.1 0.3 0.4 0.2 0.8 0.9 1.5 0.8 2.1 0.3 2-0.4 1.5-1 0.9-0.4 2.5 0.6 0.9-0.7-0.4-3.8-0.3-1.8-0.6-1.3-0.3-1.5 0.2-1.9-0.1-1.8-0.8-3.1 0.2-3.2 1.9-4.2 1.4 0.4 2.2 0.3 2.1-0.2 1-0.4 1.8-1.1 2.9-0.5 5-2.2 1.2-0.2 1.1-0.3 1.9-1.6 1.1-0.3 0 0.5-0.2 0.4-0.3 0.3-0.4 0.4-0.5 0.2 0.1 0.9-0.9 2 0.2 1.1 0.4 0 0.1-1.6 0.4-1.4 0.6-1.1 0.7-0.8 0.5-0.4 0.3-0.1 2.8 2.7 0-0.9 0.4 0 3.5 4.7 0.7 1.9 0 2.5-0.2 0.7-0.4 1 0 0.3-0.1 2.1 0.2 1 0.5 1.1 2.1 2.6 1.2 0.9 1.6 3 0.7 0.6 2.4 1.3 1.4 0.3 0.2 0.3 0.2 0.5 0 0.7 0.1 0.7 0.4 0.3 0.6 0.2 0.5 0.3 0.3 0.3 0.4 0.7 0.3 0.3 0.5 0.1 0.8 0.2 0.5 0.3 0.8 0.4 1.2-0.3 2-1.1 2.5-2.3 0.4-0.6 0.2-0.6 0.7-1.1 0.1-0.4 0.1-0.2 0.3-1.3-0.1-0.1 0.7-0.5 0.6 0 0.8 0.3 1 0.2 4.1 0 3.8 1 7 3.5 1.4 1.3 0.8 2 0.1 2.8 0.3 1.1 0.8 0.4 1 0.3 1.8 1.1 0.9 0.4 0.8 0z" id="TR55" />
                    <path d="M512.6 48.4l-1.9 4.2-0.2 3.2 0.8 3.1 0.1 1.8-0.2 1.9 0.3 1.5 0.6 1.3 0.3 1.8 0.4 3.8-0.9 0.7-2.5-0.6-0.9 0.4-1.5 1-2 0.4-2.1-0.3-1.5-0.8-0.8-0.9-0.4-0.2-2.1-0.3-0.5-0.3 0.5-0.8-1.5-0.8-0.8-0.5-0.3-0.6-0.1-1.1-0.3-1.2-0.4-0.9-0.5-0.5-0.5 0.9-1.2 0.7-2.5 1-1.6 1.5-0.6 0.2-1.2 0.1-0.4 0.3-0.5 0.5 0.4 1.1-0.7 0.8-1.1 0.5-0.8 0.6-0.1 0.4-0.1 1.1-0.1 0.5-0.2 0.3-0.9 0.8-1 1.2-5.4-1.7-0.8-0.6-0.5-0.9-1.2-0.9-1.4-0.3-1.6 0.4-1.6-0.3-0.8-0.9-1-0.2-1.8 0.1-1.2-1.6 0.3-8.3-0.5-1.2-0.3-1.2 0.5-2.4 0.9-2.2 1.4-1.4 1.5-1 1.7-4.3-2.7-3.5-3.1-0.9-5.8-0.3-2.9-0.8-2-0.3-1.7 0.1-3.1-1.2 0.1-2.1 2.4-2.9 1.3-3.7-0.2-3.6 5.5 0.7 5.4-1.6 1.8-0.1 0.7 0.2 1.4 0.7 1.6 0.6 6.3 0.4 2.5-0.3 2.5-0.8 0.8-0.4 1.7-1.4 1.8-1.1 1.4-1.8 1.1-2.1 0.3-1.9 0.6 0.2 1.4 0.3 0.6 0.4 0.1-0.4 0.2-0.1 0.3 0 0.4 0 0.3 0.8 0.5 0.5 0.4 0.4-0.3 0.5 0 0.4 1.8 1.4 1.1 0.5 1.4-0.1 0.5-0.3 0.8-0.8 0.5-0.2 0.7 0.1 0.4 0.3 1 0.9 0 0.4-2.5-0.3-1.2 0.2-1 0.8-0.5 0.9-0.4 1.4-0.2 1.5-0.1 1.2 0.3 1 1.3 2.4 1.4 1.9 2.6 2.1 0 0.5-0.7 0 0.3 0.8 0.5 1 0.6 0.9 1.4 0.7 1.4 1.7 0.7 0.6 2.8 1.1 2.1 0.4 0.8 0.5 1.5 1.4 1.7 1 0.7 0.3z" id="TR57" />
                    <path d="M99.9 68.1l7.2-1.6 7.7-0.6 5.5 0 2.7 1.8 2.1 2.8 2.6 1.7 3.1-0.8 2.7-2.1 1.7-3.5 2.3-3.4 4.6-1.4 5.2-1.2 8.2-1.1 8.3-0.9 1.3 4.5 0.5 4.2-1.4 5.2-0.7 3.8 0.7 4.8 0.5 3.5-0.4-0.2-2.3 0.8-0.4 0.3-0.4 0-2.6 1-0.7 0.2-0.9 0.5-0.7 0.5-0.5 0.5-1.1 1.8-0.3 0.8 0.1 0.5-0.9 0.2-3.8-0.4-0.7-0.5-0.7-0.6-0.8-0.4-1.8-0.6-1.8-0.1-10.2 1.5-1.4 0.9-1.1 2.1-1.2 5-1 1.9-4.5 4.4-2 3.6-4.3 3.2-0.2 0.3-0.5 0.7-0.2 0.3-0.5 0.1-1.2 0.2-1.3 0.9-2.2-0.1-1 0.1-0.8 0.7-1.4 2-0.6 0.4-1.2 0.1-1.5-4.6 0-5-6.9-0.7-1.2-4.1-1.8-3.9-0.3-5.1 0.8-4.4 1.5-3.8 2.3-3 0.7-3.8-0.3-8.8-0.6-1.1z" id="TR22" />
                    <path d="M898.8 210.6l-1.6 4.8-5.1 11.8-4 5.6-5.7 0.8-2.3 2.9-1.9-0.7 0.8-3.5-1.1-3 0.4-3.2 0.8-3.1 1.3-2.9 4.7-7 2.1-4.2 0.1-0.5 0.2-0.9-0.3-0.4-0.3-0.3-0.2 0-0.4 0-0.6-2.2 0.1-2.4-0.5-1.7 0.1-1.5 6-3.3 0.5-1.3 0.6-1.3 1.4-0.8 0.7-0.3 2-1.2 3.4-2.8 3.8-1.4 4.2 0.3 0.7 2 0.9 1.8 1.8 0.6 1.8-0.8 5.2-3.8 1.4-0.7 1.3-0.9 2.2-2.3 2.3 1.6 2.2 3 1.8 2 2.1 1.6 3.3 0.6 3-0.1 2.8 1.8 1.6 4.8 1.3 2.9 2.9 4.4 0.4 1 0.9 1.1 0.7-0.1 1.4 0.2 1 1.4 0.7 1.7z" id="TR35" />
                    <path d="M163.8 57.8l0.1 0 2.2-3 1.4 1.3 7.2 4.6 10.3 4.4 14.6 7 4.7 1.1 0.2 0.1 0.1 0.1 0.2 0.2 0.3 0 0.3-0.1 0.3-0.6 0.4-0.1 1.1 0.1 1.2 0.5 0.7 0.7-0.4 1.6-0.7 1.1-0.8 1.1-0.8 0.5-0.6 0.2 0.2 0.4 0.4 0.5 0.2 0.5 0.3 0.4 0.1 0.1 0.3 0.2-0.1 0.4-0.2 0.3-0.1 0-0.2 1.2-0.3 1.2-0.5 0.9-0.5 0.8-0.4 0.3-0.8 0.3-0.4 0.3-0.4 0.6-0.1 0.3 0.1 0.3 0 0.2 0.2 0.3-0.1 0.3-0.2 0.4-0.2 0-1.1-0.1-0.4-0.3-0.2-0.1-0.3 0.2-0.4 0.6-0.2 0.1-0.5 0.1-0.9 0.6-1.9 0.4-0.4 0.2-0.3 0.2-0.2 0.3-0.3 0.2-0.5 0.1-1.2 0-0.6-0.2-0.2-0.4-0.5-0.5-1.2 0-5.7 0.7-1.4-0.6 0.4-2-0.6-0.6-0.3-0.2-0.4-0.1 0.3-1.4-0.5-1.3-1-0.8-1.1-0.3 0.2 0.9 1.1 1 0.3 1.1 0 0.6-0.1 0.9-0.3 0.9-0.6 0.6-1.3-0.2-2.5-2.5-1.2-0.7-1.6-0.3-3.3-1.2-1.6-0.2-1.6 0-0.4-0.2-0.5-0.6-0.4-0.1-1.8 0.4-0.9 0-0.3-0.2-0.5-3.5-0.7-4.8 0.7-3.8 1.4-5.2-0.5-4.2-1.3-4.5z" id="TR34" />
                    <path d="M216 96.7l1.6-2.1 2.5-2.1 1.1-0.6 2-2 2.1-1.5 2.5 0.2 2.3 1.9 1.4 3.1 1.4 1.2 1.7-0.2 0.8-1.5 0.5-1.5 2.7-1.9 3.1-1.2 2.5-1.4 1.4-3.2-0.2-2-0.5-1.9 1-0.5 12 0.4 1.3-0.2 0.7-0.3 1.2-0.8 0.6-0.2 0.4-0.4 0.4-0.7 0.3-0.5 0.4 0.3 0.5-0.5 0.6-1 0.5-0.3 0.6 0.5 2 0.5 1.6 1.2 2.8 0.7-0.3 0.9-1.5 3.9 0.9 3.2 3.4 0.6 0.3 2.1-1.1 1.9-0.3 2.2-0.9 0.1-2.6 0.1-1.6-0.7-1.8-0.4-0.9 0.5 0.4 1.4 0.6 0.2 0.6 0.4-3.1 3.3-1.9 9.3-1.9 3.9-2.8 1.9-3.1 0.7-1.5 0.9-1.5 0.5-3.3 0.3-6.5-2.3-3.3 0.6-8.8 3.3-2.7 0.2-2.7-0.9 0.4-2.4 0-5.6 0.4-0.3 0.6-0.2 0.5-0.3 0.2-0.5 0.2-0.4 0.5-0.4 0.5-0.2 0.5-0.1 0.5 0.1 0.8 0.4 0.7 0.7 0.3 1.2 0.5 0 9.2-2.1 5.4-0.3 1.7 0.8 1 0 0.7-1.1-0.5-1.5-1.8-0.3-3.9 0.5-0.3 0.1-0.3 0.1-0.4 0.2-0.6 0-0.5-0.3-1-0.8-0.3-0.2-0.7-0.2-1.7-0.6-1-0.1-11.2 0.5-0.9 0.3-0.8 0.6-0.8 0.3-0.9-0.4-0.4-0.5-0.2-0.6-0.3-0.4-0.5-0.2 0.2-0.1 0.1-0.2 0.2-0.1 0.2-0.1-0.2-0.6-0.3-0.4-0.3-0.4-0.5-0.2-0.2 0.3-0.5-0.3-0.4 0.3-0.5 0.2-1.3 0.3 0-0.4 0.5 0 0.3-0.3 0.1-0.4 0-0.6 0.5 0.3 0.2 0.1 0-0.2 0-0.2 0.1 0 0.2 0-0.5-0.9-1-1.1-0.4-0.4z" id="TR16" />
                    <path d="M716.4 101l-1.4 1.2-1.5 1-0.6 1.6 0.6 1.9-0.9 1.7-1.4 1.5-0.5 0.7-0.1 0.5-0.3 2.8 0.1 2.2 1.3 1.6 5.6 1.4 1.3 1.3 1.1 0.3 0.3 2.3-1.4 1.2-4.8 2.6-1 1.3-0.1 2.1 0.2 2.1 0.2 2.2 0.4 2.2 1.3 1.7-0.4 2 1.4 0.3 1.4 0.6 1.3 0.8-1.9 0.9-4.2-0.3-1.9 4.2-0.6 2-0.2 2 1 4.2 1.8 3.9-2.5 1-2.7-0.3-2.4 0.3-1.9 1.8-2.3 0.8 2.8-1.4 2.9-0.9 2.9-0.3 2.8 1.4 2.9 0.9 0.8 0.8 0.7 1.1 1.8 1.1 1.8 0.7 5.2 3.1 1.4 0.3 1.4 0.3 1.4 0.6 1.3 0.8z" id="TR61" />
                    <path d="M261 342l2.3-1.6 0.9-3.2-0.6-3.7 11.8-5.1 4-5.6 5.7-0.8 2.3-2.9 1.9 0.7-0.8 3.5 1.1 3-0.4 3.2-0.8 3.1-1.3 2.9-4.7 7-2.1 4.2-0.1 0.5-0.2 0.9 0.3 0.4 0.3 0.3 0.2 0 0.4 0 0.6 2.2-0.1 2.4 0.5 1.7-0.1 1.5-6 3.3-0.5 1.3-0.6 1.3-1.4 0.8-0.7 0.3-2 1.2-3.4 2.8 1.2-0.4 0.5-1.8 1.2-0.4 1.7 0 2.2-0.9 1.4-2.5 0.7-2.7 1.6-2.3 3.5-0.6 0.6-0.6 0.8-1.6 0.6-0.6 3.5-1.6 2.8-2.8 0.7-2.3 0.4-2.3 0.1-1.9 0.2-1 1.2-1.1 2.6-0.2 4.7-2.6 1.7 0.8 0.9 1.3 0.6 1.5-0.3 3.9-2.2 1.8-1.1 3 0.8 3.5-1.9 0.7-2.3 2.9-5.7 0.8-4z" id="TR07" />
                    <path d="M374.2 163.1l2.6-3.1 2.1-3.6 0.4-6.3 1.3-1.1 1.4-0.7 0.8-1.2 0.8-1.4 2.4-1 2.6 0 2.4-1.8 1.6-2.8 0.6-3.3 0.9-3.1 3.8-3.1 4.9-0.2-0.8 5.2 0.2 2.7 1.7 3.3 0.7 1 1.9 1.2 1.7 0.7 5.2 3.8 2.1 0.5 3.7-1 3.6-0.4 1.8-0.5 1.8 3 5.2 5 1.3 3.7 0.6 4.7 4.7 6.3 0.9 3.9-3.3 5.1-5.7 2.6-0.9 2.5-0.7 2.7-1.3 2.6-1.3 4.1-1.9 3.2-1.4 1.8-9.8 5.9z" id="TR06" />
                    {/* Additional provinces simplified for performance */}
                    <path d="M270.9 341.5l2.3-1.6 0.9-3.2-0.6-3.7 11.8-5.1 4-5.6 5.7-0.8 2.3-2.9 1.9 0.7" />
                    <path d="M511.6 315.2l-3.3-0.8-3.3 1.4-1.5 0.9-1.6 0.6-3.5 0.1-1.1-2.6-1.8-1.9-1.2-1-1.8-2.6" />
                  </g>
                  
                  {/* Sixt Branch Markers - Only on provinces with branches */}
                  
                  {/* Istanbul Atatürk - TR34 */}
                  <circle
                    cx="176.3"
                    cy="73.8"
                    r="12"
                    fill="#ef4444"
                    stroke="white"
                    strokeWidth="3"
                    className="cursor-pointer hover:scale-110 transition-transform duration-200 drop-shadow-lg"
                    onClick={() => setSelectedMapBranch('Istanbul Atatürk Airport')}
                  />
                  <text
                    x="176.3"
                    y="79"
                    textAnchor="middle"
                    fill="white"
                    fontSize="11"
                    fontWeight="bold"
                    className="pointer-events-none"
                  >
                    İST
                  </text>
                  
                  {/* Ankara Esenboğa - TR06 */}
                  <circle
                    cx="374.2"
                    cy="163.1"
                    r="10"
                    fill="#ec4899"
                    stroke="white"
                    strokeWidth="3"
                    className="cursor-pointer hover:scale-110 transition-transform duration-200 drop-shadow-lg"
                    onClick={() => setSelectedMapBranch('Ankara Esenboğa Airport')}
                  />
                  <text
                    x="374.2"
                    y="168"
                    textAnchor="middle"
                    fill="white"
                    fontSize="10"
                    fontWeight="bold"
                    className="pointer-events-none"
                  >
                    ANK
                  </text>
                  
                  {/* İzmir Adnan Menderes - TR35 */}
                  <circle
                    cx="127.6"
                    cy="259"
                    r="10"
                    fill="#22c55e"
                    stroke="white"
                    strokeWidth="3"
                    className="cursor-pointer hover:scale-110 transition-transform duration-200 drop-shadow-lg"
                    onClick={() => setSelectedMapBranch('İzmir Adnan Menderes')}
                  />
                  <text
                    x="127.6"
                    y="264"
                    textAnchor="middle"
                    fill="white"
                    fontSize="10"
                    fontWeight="bold"
                    className="pointer-events-none"
                  >
                    İZM
                  </text>
                  
                  {/* Antalya Airport - TR07 */}
                  <circle
                    cx="260.9"
                    cy="341.5"
                    r="10"
                    fill="#f59e0b"
                    stroke="white"
                    strokeWidth="3"
                    className="cursor-pointer hover:scale-110 transition-transform duration-200 drop-shadow-lg"
                    onClick={() => setSelectedMapBranch('Antalya Airport')}
                  />
                  <text
                    x="260.9"
                    y="347"
                    textAnchor="middle"
                    fill="white"
                    fontSize="10"
                    fontWeight="bold"
                    className="pointer-events-none"
                  >
                    AYT
                  </text>
                  
                  {/* Bursa City Center - TR16 */}
                  <circle
                    cx="205.6"
                    cy="151.1"
                    r="9"
                    fill="#3b82f6"
                    stroke="white"
                    strokeWidth="3"
                    className="cursor-pointer hover:scale-110 transition-transform duration-200 drop-shadow-lg"
                    onClick={() => setSelectedMapBranch('Bursa City Center')}
                  />
                  <text
                    x="205.6"
                    y="156"
                    textAnchor="middle"
                    fill="white"
                    fontSize="9"
                    fontWeight="bold"
                    className="pointer-events-none"
                  >
                    BUR
                  </text>
                  
                  {/* Trabzon Airport - TR61 */}
                  <circle
                    cx="716.4"
                    cy="101"
                    r="9"
                    fill="#8b5cf6"
                    stroke="white"
                    strokeWidth="3"
                    className="cursor-pointer hover:scale-110 transition-transform duration-200 drop-shadow-lg"
                    onClick={() => setSelectedMapBranch('Trabzon Airport')}
                  />
                  <text
                    x="716.4"
                    y="106"
                    textAnchor="middle"
                    fill="white"
                    fontSize="9"
                    fontWeight="bold"
                    className="pointer-events-none"
                  >
                    TZX
                  </text>
                  
                  {/* Visual Enhancements */}
                  <defs>
                    <filter id="glow">
                      <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
                      <feMerge> 
                        <feMergeNode in="coloredBlur"/>
                        <feMergeNode in="SourceGraphic"/>
                      </feMerge>
                    </filter>
                    <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
                      <feDropShadow dx="2" dy="2" stdDeviation="2" flood-color="#000" flood-opacity="0.3"/>
                    </filter>
                  </defs>
                </svg>
              </div>
            </div>
            
            {/* Selected Branch Details */}
            <div className="bg-white border rounded-lg p-4">
              <h4 className="font-semibold mb-3 text-gray-800">Şube Detayları</h4>
              {selectedMapBranch ? (
                <div className="space-y-3">
                  <div className="pb-2 border-b">
                    <h5 className="font-medium text-blue-600">{selectedMapBranch}</h5>
                  </div>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Gelir:</span>
                      <span className="font-medium">₺{branchData.find(b => b.name === selectedMapBranch)?.revenue.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Büyüme:</span>
                      <span className={`font-medium ${branchData.find(b => b.name === selectedMapBranch)?.revenueGrowth >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                        {branchData.find(b => b.name === selectedMapBranch)?.revenueGrowth >= 0 ? '+' : ''}{branchData.find(b => b.name === selectedMapBranch)?.revenueGrowth}%
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Kullanım Oranı:</span>
                      <span className="font-medium">{branchData.find(b => b.name === selectedMapBranch)?.vehicleUtilization}%</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Filo Durumu:</span>
                      <span className="font-medium">{branchData.find(b => b.name === selectedMapBranch)?.activeRentals}/{branchData.find(b => b.name === selectedMapBranch)?.totalFleet}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Müşteri Sayısı:</span>
                      <span className="font-medium">{branchData.find(b => b.name === selectedMapBranch)?.totalCustomers.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Memnuniyet:</span>
                      <span className="font-medium">{branchData.find(b => b.name === selectedMapBranch)?.customerSatisfaction}/5</span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-center text-gray-500 py-8">
                  <MapPin className="h-12 w-12 mx-auto mb-2 text-gray-300" />
                  <p>Şube detaylarını görmek için haritadan bir marker seçin</p>
                </div>
              )}
            </div>
          </div>
          
          {/* Map Legend */}
          <div className="mt-4 pt-4 border-t">
            <h4 className="text-sm font-medium mb-2 text-gray-700">Şube Renk Kodları:</h4>
            <div className="flex flex-wrap gap-4 text-xs">
              <div className="flex items-center">
                <div className="w-3 h-3 rounded-full bg-red-500 mr-2"></div>
                <span>Istanbul Atatürk</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 rounded-full bg-pink-500 mr-2"></div>
                <span>Ankara Esenboğa</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 rounded-full bg-green-500 mr-2"></div>
                <span>İzmir Adnan Menderes</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 rounded-full bg-yellow-500 mr-2"></div>
                <span>Antalya Airport</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 rounded-full bg-blue-500 mr-2"></div>
                <span>Bursa City Center</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 rounded-full bg-purple-500 mr-2"></div>
                <span>Trabzon Airport</span>
              </div>
            </div>
          </div>
        </div>

        {/* Branch Performance Table */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-100">
            <h3 className="text-lg font-semibold text-gray-900">Branch Performance Details</h3>
          </div>
          
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Branch
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Revenue
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Growth
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Utilization
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Fleet Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Customers
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Satisfaction
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Target Achievement
                  </th>
                  <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Monthly Details
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {sortedBranches.map((branch) => (
                  <React.Fragment key={branch.id}>
                    <tr className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="flex-shrink-0">
                            <MapPin className="w-5 h-5 text-gray-400" />
                          </div>
                          <div className="ml-3">
                            <div className="text-sm font-medium text-gray-900">{branch.name}</div>
                            <div className="text-sm text-gray-500">{branch.location}</div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900">{formatCurrency(branch.revenue)}</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className={`flex items-center gap-1 text-sm ${
                          branch.revenueGrowth >= 0 ? 'text-green-600' : 'text-red-600'
                        }`}>
                          {branch.revenueGrowth >= 0 ? (
                            <ArrowUpRight className="w-4 h-4" />
                          ) : (
                            <ArrowDownRight className="w-4 h-4" />
                          )}
                          {Math.abs(branch.revenueGrowth)}%
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="text-sm font-medium text-gray-900">{branch.vehicleUtilization}%</div>
                          <div className="ml-2 w-16 bg-gray-200 rounded-full h-2">
                            <div
                              className="bg-orange-600 h-2 rounded-full"
                              style={{ width: `${branch.vehicleUtilization}%` }}
                            ></div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">
                          {branch.activeRentals}/{branch.totalFleet}
                        </div>
                        <div className="text-xs text-gray-500">
                          {branch.fleetStatus.available} available, {branch.fleetStatus.maintenance} maintenance
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900">{branch.totalCustomers.toLocaleString()}</div>
                        <div className="text-xs text-gray-500">{(branch.revenuePerCustomer / branch.averageDailyRate).toFixed(1)} days avg</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <span className="text-sm font-medium text-gray-900">{branch.customerSatisfaction}</span>
                          <span className="text-yellow-400 ml-1">★</span>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center gap-2">
                          <div className={`text-sm font-medium ${
                            branch.achievementRate >= 100 ? 'text-green-600' : 'text-orange-600'
                          }`}>
                            {branch.achievementRate}%
                          </div>
                          <div className="w-12 bg-gray-200 rounded-full h-2">
                            <div
                              className={`h-2 rounded-full ${
                                branch.achievementRate >= 100 ? 'bg-green-500' : 'bg-orange-500'
                              }`}
                              style={{ width: `${Math.min(branch.achievementRate, 100)}%` }}
                            ></div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <button
                          onClick={() => toggleBranchExpansion(branch.name)}
                          className="inline-flex items-center px-3 py-1 border border-gray-300 shadow-sm text-xs font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
                        >
                          {expandedBranches[branch.name] ? (
                            <>
                              <ChevronUp className="w-4 h-4 mr-1" />
                              Hide
                            </>
                          ) : (
                            <>
                              <ChevronDown className="w-4 h-4 mr-1" />
                              Show
                            </>
                          )}
                        </button>
                      </td>
                    </tr>
                    
                    {/* Monthly breakdown row */}
                    {expandedBranches[branch.name] && branchMonthlyTrends[branch.name] && (
                      <tr className="bg-gray-50">
                        <td colSpan="9" className="px-6 py-4">
                          <div className="space-y-4">
                            <h4 className="text-sm font-medium text-gray-900">
                              6-Month Performance Breakdown: {branch.name}
                            </h4>
                            
                            {/* Monthly chart */}
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                              {/* Revenue Trend */}
                              <div className="bg-white rounded-lg p-4 border border-gray-200">
                                <h5 className="text-sm font-medium text-gray-700 mb-3">Revenue Trend</h5>
                                <div className="h-32 flex items-end justify-between space-x-2">
                                  {branchMonthlyTrends[branch.name].map((monthData, index) => {
                                    const maxRevenue = Math.max(...branchMonthlyTrends[branch.name].map(m => m.revenue));
                                    const height = (monthData.revenue / maxRevenue) * 100;
                                    
                                    return (
                                      <div key={index} className="flex flex-col items-center flex-1">
                                        <div 
                                          className="bg-green-500 rounded-t w-full transition-all duration-300 hover:bg-green-600"
                                          style={{ height: `${height}px` }}
                                          title={`${monthData.month}: ${formatCurrency(monthData.revenue)}`}
                                        ></div>
                                        <span className="text-xs text-gray-600 mt-1">{monthData.month}</span>
                                        <span className="text-xs text-gray-500">{formatCurrency(monthData.revenue / 1000)}K</span>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                              
                              {/* Utilization Trend */}
                              <div className="bg-white rounded-lg p-4 border border-gray-200">
                                <h5 className="text-sm font-medium text-gray-700 mb-3">Utilization Trend</h5>
                                <div className="h-32 flex items-end justify-between space-x-2">
                                  {branchMonthlyTrends[branch.name].map((monthData, index) => {
                                    const height = monthData.utilization; // Already percentage
                                    
                                    return (
                                      <div key={index} className="flex flex-col items-center flex-1">
                                        <div 
                                          className="bg-blue-500 rounded-t w-full transition-all duration-300 hover:bg-blue-600"
                                          style={{ height: `${height}px` }}
                                          title={`${monthData.month}: ${monthData.utilization.toFixed(1)}%`}
                                        ></div>
                                        <span className="text-xs text-gray-600 mt-1">{monthData.month}</span>
                                        <span className="text-xs text-gray-500">{monthData.utilization.toFixed(1)}%</span>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                            
                            {/* Monthly data table */}
                            <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                              <table className="w-full text-sm">
                                <thead className="bg-gray-100">
                                  <tr>
                                    <th className="px-4 py-2 text-left font-medium text-gray-600">Month</th>
                                    <th className="px-4 py-2 text-right font-medium text-gray-600">Revenue</th>
                                    <th className="px-4 py-2 text-right font-medium text-gray-600">Growth</th>
                                    <th className="px-4 py-2 text-right font-medium text-gray-600">Utilization</th>
                                    <th className="px-4 py-2 text-right font-medium text-gray-600">Customers</th>
                                    <th className="px-4 py-2 text-right font-medium text-gray-600">Satisfaction</th>
                                  </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                  {branchMonthlyTrends[branch.name].map((monthData, index) => {
                                    const previousMonth = branchMonthlyTrends[branch.name][index - 1];
                                    const monthlyGrowth = previousMonth ? 
                                      ((monthData.revenue - previousMonth.revenue) / previousMonth.revenue * 100).toFixed(1) : null;
                                    
                                    return (
                                      <tr key={index} className="hover:bg-gray-50">
                                        <td className="px-4 py-2 font-medium text-gray-800">{monthData.month}</td>
                                        <td className="px-4 py-2 text-right text-gray-600">{formatCurrency(monthData.revenue)}</td>
                                        <td className="px-4 py-2 text-right">
                                          {monthlyGrowth !== null ? (
                                            <span className={`${monthlyGrowth >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                                              {monthlyGrowth > 0 ? '+' : ''}{monthlyGrowth}%
                                            </span>
                                          ) : (
                                            <span className="text-gray-400">-</span>
                                          )}
                                        </td>
                                        <td className="px-4 py-2 text-right text-gray-600">{monthData.utilization.toFixed(1)}%</td>
                                        <td className="px-4 py-2 text-right text-gray-600">{monthData.customers}</td>
                                        <td className="px-4 py-2 text-right text-gray-600">{monthData.satisfaction}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Summary Insights */}
        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <TrendingUp className="w-5 h-5 text-green-600" />
              Top Performers
            </h3>
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-600">Highest Revenue:</span>
                <span className="text-sm font-medium text-gray-900">Antalya Airport</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-600">Best Utilization:</span>
                <span className="text-sm font-medium text-gray-900">Antalya Airport (91.2%)</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-600">Highest Growth:</span>
                <span className="text-sm font-medium text-gray-900">Antalya Airport (+18.3%)</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-600">Best Satisfaction:</span>
                <span className="text-sm font-medium text-gray-900">Antalya Airport (4.8/5.0)</span>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <TrendingDown className="w-5 h-5 text-red-600" />
              Areas for Improvement
            </h3>
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-600">Lowest Utilization:</span>
                <span className="text-sm font-medium text-gray-900">Trabzon Airport (59.7%)</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-600">Declining Growth:</span>
                <span className="text-sm font-medium text-gray-900">Trabzon Airport (-8.1%)</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-600">Below Target:</span>
                <span className="text-sm font-medium text-gray-900">3 out of 6 branches</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-600">Fleet Optimization:</span>
                <span className="text-sm font-medium text-gray-900">Needed in 2 locations</span>
              </div>
            </div>
          </div>
        </div>

        {/* Monthly Trend Analysis Section */}
        <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-gradient-to-r from-purple-500 to-pink-600 rounded-xl">
                <LineChart className="w-6 h-6 text-white" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-800">Monthly Trend Analysis</h2>
                <p className="text-sm text-gray-500">6-month performance tracking</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={() => setSelectedTimeframe('current')}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  selectedTimeframe === 'current'
                    ? 'bg-blue-100 text-blue-700'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                Current Month
              </button>
              <button
                onClick={() => setSelectedTimeframe('trends')}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  selectedTimeframe === 'trends'
                    ? 'bg-blue-100 text-blue-700'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                6-Month Trends
              </button>
            </div>
          </div>

          {/* Monthly Growth Overview */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
            <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-4 border border-green-100">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-green-600">Revenue Growth</p>
                  <p className="text-2xl font-bold text-green-700">
                    {monthlyGrowth.revenue > 0 ? '+' : ''}{monthlyGrowth.revenue}%
                  </p>
                  <p className="text-xs text-green-500">vs last month</p>
                </div>
                <div className="p-2 bg-green-100 rounded-lg">
                  {monthlyGrowth.revenue >= 0 ? (
                    <TrendingUp className="w-5 h-5 text-green-600" />
                  ) : (
                    <TrendingDown className="w-5 h-5 text-red-600" />
                  )}
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl p-4 border border-blue-100">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-blue-600">Utilization Growth</p>
                  <p className="text-2xl font-bold text-blue-700">
                    {monthlyGrowth.utilization > 0 ? '+' : ''}{monthlyGrowth.utilization}%
                  </p>
                  <p className="text-xs text-blue-500">vs last month</p>
                </div>
                <div className="p-2 bg-blue-100 rounded-lg">
                  <Car className="w-5 h-5 text-blue-600" />
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-orange-50 to-amber-50 rounded-xl p-4 border border-orange-100">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-orange-600">Customer Growth</p>
                  <p className="text-2xl font-bold text-orange-700">
                    {monthlyGrowth.customers > 0 ? '+' : ''}{monthlyGrowth.customers}%
                  </p>
                  <p className="text-xs text-orange-500">vs last month</p>
                </div>
                <div className="p-2 bg-orange-100 rounded-lg">
                  <Users className="w-5 h-5 text-orange-600" />
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-purple-50 to-violet-50 rounded-xl p-4 border border-purple-100">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-purple-600">ROAS Growth</p>
                  <p className="text-2xl font-bold text-purple-700">
                    {monthlyGrowth.roas > 0 ? '+' : ''}{monthlyGrowth.roas}%
                  </p>
                  <p className="text-xs text-purple-500">vs last month</p>
                </div>
                <div className="p-2 bg-purple-100 rounded-lg">
                  <Target className="w-5 h-5 text-purple-600" />
                </div>
              </div>
            </div>
          </div>

          {/* Trend Chart Section */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Company-wide Trends */}
            <div className="bg-gray-50 rounded-xl p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-gray-800">Company-wide Trends</h3>
                <select
                  value={selectedTrendMetric}
                  onChange={(e) => setSelectedTrendMetric(e.target.value)}
                  className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="revenue">Revenue</option>
                  <option value="utilization">Utilization</option>
                  <option value="customers">Customers</option>
                  <option value="roas">ROAS</option>
                </select>
              </div>
              
              {/* Simplified Chart */}
              <div className="h-64 flex items-end justify-between space-x-2">
                {monthlyTrendData.map((month, index) => {
                  let value, maxValue, color;
                  
                  switch(selectedTrendMetric) {
                    case 'revenue':
                      value = month.totalRevenue;
                      maxValue = Math.max(...monthlyTrendData.map(m => m.totalRevenue));
                      color = 'bg-green-500';
                      break;
                    case 'utilization':
                      value = month.averageUtilization;
                      maxValue = Math.max(...monthlyTrendData.map(m => m.averageUtilization));
                      color = 'bg-blue-500';
                      break;
                    case 'customers':
                      value = month.totalCustomers;
                      maxValue = Math.max(...monthlyTrendData.map(m => m.totalCustomers));
                      color = 'bg-orange-500';
                      break;
                    case 'roas':
                      value = month.averageROAS;
                      maxValue = Math.max(...monthlyTrendData.map(m => m.averageROAS));
                      color = 'bg-purple-500';
                      break;
                    default:
                      value = month.totalRevenue;
                      maxValue = Math.max(...monthlyTrendData.map(m => m.totalRevenue));
                      color = 'bg-green-500';
                  }
                  
                  const height = (value / maxValue) * 200;
                  
                  return (
                    <div key={index} className="flex flex-col items-center">
                      <div 
                        className={`w-8 ${color} rounded-t transition-all duration-300 hover:opacity-80`}
                        style={{ height: `${height}px` }}
                        title={`${month.month}: ${
                          selectedTrendMetric === 'revenue' ? formatCurrency(value) :
                          selectedTrendMetric === 'utilization' ? `${value.toFixed(1)}%` :
                          selectedTrendMetric === 'customers' ? value.toLocaleString() :
                          value.toFixed(1)
                        }`}
                      ></div>
                      <span className="text-xs text-gray-600 mt-2 text-center">{month.shortMonth}</span>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Branch-specific Trends */}
            <div className="bg-gray-50 rounded-xl p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-gray-800">Branch-specific Trends</h3>
                <select
                  value={selectedBranch}
                  onChange={(e) => setSelectedBranch(e.target.value)}
                  className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  {Object.keys(branchMonthlyTrends).map(branch => (
                    <option key={branch} value={branch}>{branch}</option>
                  ))}
                </select>
              </div>
              
              {/* Branch Revenue and Utilization Trend */}
              <div className="h-64">
                <div className="flex justify-between text-xs text-gray-500 mb-2">
                  <span>Revenue (TL)</span>
                  <span>Utilization (%)</span>
                </div>
                
                <div className="h-52 flex items-end justify-between space-x-1">
                  {branchMonthlyTrends[selectedBranch]?.map((month, index) => {
                    const maxRevenue = Math.max(...branchMonthlyTrends[selectedBranch].map(m => m.revenue));
                    const revenueHeight = (month.revenue / maxRevenue) * 180;
                    const utilizationHeight = (month.utilization / 100) * 180;
                    
                    return (
                      <div key={index} className="flex flex-col items-center flex-1">
                        <div className="flex items-end space-x-1 mb-2">
                          <div 
                            className="bg-green-500 rounded-t w-3"
                            style={{ height: `${revenueHeight}px` }}
                            title={`Revenue: ${formatCurrency(month.revenue)}`}
                          ></div>
                          <div 
                            className="bg-blue-500 rounded-t w-3"
                            style={{ height: `${utilizationHeight}px` }}
                            title={`Utilization: ${month.utilization.toFixed(1)}%`}
                          ></div>
                        </div>
                        <span className="text-xs text-gray-600 text-center">{month.month}</span>
                      </div>
                    );
                  })}
                </div>
                
                <div className="flex justify-center space-x-4 mt-4">
                  <div className="flex items-center space-x-2">
                    <div className="w-3 h-3 bg-green-500 rounded"></div>
                    <span className="text-xs text-gray-600">Revenue</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="w-3 h-3 bg-blue-500 rounded"></div>
                    <span className="text-xs text-gray-600">Utilization</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Monthly Performance Table */}
          <div className="mt-8">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Monthly Performance Summary</h3>
            <div className="overflow-x-auto">
              <table className="w-full bg-white rounded-lg border border-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Month</th>
                    <th className="px-4 py-3 text-right text-sm font-medium text-gray-600">Total Revenue</th>
                    <th className="px-4 py-3 text-right text-sm font-medium text-gray-600">Avg Utilization</th>
                    <th className="px-4 py-3 text-right text-sm font-medium text-gray-600">Total Customers</th>
                    <th className="px-4 py-3 text-right text-sm font-medium text-gray-600">Fleet Size</th>
                    <th className="px-4 py-3 text-right text-sm font-medium text-gray-600">Revenue/Vehicle</th>
                    <th className="px-4 py-3 text-center text-sm font-medium text-gray-600">Growth</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {monthlyTrendData.map((month, index) => {
                    const previousMonth = monthlyTrendData[index - 1];
                    const revenueGrowth = previousMonth ? 
                      calculateGrowth(month.totalRevenue, previousMonth.totalRevenue) : null;
                    
                    return (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="px-4 py-4 text-sm font-medium text-gray-800">{month.month}</td>
                        <td className="px-4 py-4 text-sm text-gray-600 text-right">{formatCurrency(month.totalRevenue)}</td>
                        <td className="px-4 py-4 text-sm text-gray-600 text-right">{month.averageUtilization.toFixed(1)}%</td>
                        <td className="px-4 py-4 text-sm text-gray-600 text-right">{month.totalCustomers.toLocaleString()}</td>
                        <td className="px-4 py-4 text-sm text-gray-600 text-right">{month.totalFleet}</td>
                        <td className="px-4 py-4 text-sm text-gray-600 text-right">{month.revenuePerVehicle.toLocaleString()} ₺</td>
                        <td className="px-4 py-4 text-center">
                          {revenueGrowth !== null ? (
                            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                              revenueGrowth >= 0 
                                ? 'bg-green-100 text-green-800' 
                                : 'bg-red-100 text-red-800'
                            }`}>
                              {revenueGrowth >= 0 ? (
                                <ArrowUpRight className="w-3 h-3 mr-1" />
                              ) : (
                                <ArrowDownRight className="w-3 h-3 mr-1" />
                              )}
                              {revenueGrowth > 0 ? '+' : ''}{revenueGrowth}%
                            </span>
                          ) : (
                            <span className="text-xs text-gray-400">-</span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
} 